import { render } from "./FramelessProjects.vue?vue&type=template&id=e3744bd2&scoped=true"
import script from "./FramelessProjects.vue?vue&type=script&lang=js"
export * from "./FramelessProjects.vue?vue&type=script&lang=js"

import "./FramelessProjects.vue?vue&type=style&index=0&id=e3744bd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3744bd2"]])

export default __exports__